<template>
  <div class="newpricing" id="newpricing">

    <table class="table-responsive table-flush table-striped">

      <tbody>
        <tr v-for="product in offer.pricing.products" :key="product.name">
          <td colspan="2">{{ product.name }}</td>

          <td></td>
          <td>{{ financial(product.price_net) }} €</td>
        </tr>

        <tr v-if="offer.option_discount_protection_fv || offer.option_discount_protection_kh">
          <td colspan="4">Rabattschutz in Prämie enthalten</td>

        </tr>
        <tr v-if="offer.pricing.products">
          <td colspan="4">SF Haftpflicht {{ offer.customer_sf }}</td>
        </tr>
        <tr v-if="offer.pricing.products">
          <td colspan="4">SF Kasko {{ offer.customer_sf2 }}</td>
        </tr>
        <!-- tr>
          <td colspan="5">
            <hr />
          </td>
        </tr>
        <tr>
          <td width="20px"></td>
          <td>oPTION</td>
          <td></td>
          <td></td>
        </tr -->

        <tr>
          <td colspan="5">
            <hr />
          </td>
        </tr>


        <tr>
          <td>
           Summe Netto 
          </td>
          <td>
            <!-- strong> Jährlich </strong -->
          </td>
          <td></td>
          <td>
            {{ financial(offer.pricing.price_net_complete) || 0 }} € 
          </td>
        </tr>



        <tr>
          <td>
            <strong> Bruttobeitrag </strong>
          </td>
          <td>
            <!-- strong> Jährlich </strong -->
          </td>
          <td></td>
          <td>
            <strong>{{ financial(offer.pricing.price_brut_complete) || 0 }} € </strong>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            davon gesetzliche Versicherungssteuer von zurzeit 19% Jährlich
          </td>
          <td>{{ financial(offer.pricing.price_tax_complete) || 0 }} €</td>
        </tr>

      </tbody>
    </table>
          <base-button type="info" class="mb-3" @click="$emit('calculate', 'now')"><i class="fas fa-file-pdf"></i> Jetzt kalkulieren</base-button>
          <base-button v-if="offer.pricing.products" type="warning" class="mb-3" @click="downloadFile(offer.id, 'offer')"><i class="fas fa-file-pdf"></i> Angebot herunterladen</base-button>
          <base-button v-if="offer.pricing.products" type="success" class="mb-3" @click="acceptOffer(offer.id)"><i class="fas fa-check"></i> Jetzt annehmen</base-button>
          <!-- base-button v-if="offer.pricing.products && this.offer.state != 'accepted'" type="success" class="mb-3" @click="acceptOffer(offer.id)"><i class="fas fa-check"></i> Jetzt annehmen</base-button -->
  </div>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip } from 'element-ui'
import { mapGetters, mapState } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "pricing",
  components: {
    flatPicker,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    acceptOffer() {
      this.$router.push({
        name: "Angebot annehmen",
        params: { token: `${this.offer.id}` },
      })
    },
    downloadFile(id, name) {
      this.loading = true;
      this.$api
        .getOfferDocument(id, name)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const objectUrl = window.URL.createObjectURL(blob);
          window.open(objectUrl);
          this.loading = false;
        })
        .catch(console.error);
    },
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      //return (Math.round(x * 100) / 100).toFixed(2);
      return Number.parseFloat(x).toFixed(2);
    },
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
      pricing: (state) => state.offer.pricing,
    }),
  },
  watch: {
  },
  mounted() {
  },
};
</script>
<style>
</style>